import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Data Map';

const GOOGLE_MAP_EVENT_NAMES = {
  SWITCH_SATELLITE: 'map_switch_satellite_view',
  ZOOM_IN: 'map_zoom_in',
  ZOOM_OUT: 'map_zoom_out',
};

export const addSatelliteButtonClickListener = () => {
  let satelliteButton = document.querySelector(
    '[aria-label="Show satellite imagery"]',
  );
  if (satelliteButton) {
    satelliteButton.addEventListener('click', () => {
      gspx.trackEvent({
        name: GOOGLE_MAP_EVENT_NAMES.SWITCH_SATELLITE,
        type: GPX_EVENT_TYPES.INFO,
        feature: GPX_FEATURES.LEGACY,
        capability: GPX_CAPABILITIES.LEGACY,
        route: GPX_ROUTES.MAP,
        additionalKeys: {
          legacy_category: LEGACY_CATEGORY,
          legacy_name: 'Switch to satellite view',
          Category: 'Google Map',
          'Launched date': new Date(),
        },
      });
    });
  }
};

export const addZoomInButtonClickListener = () => {
  let zoomInButton = document.querySelector('[aria-label="Zoom in"]');
  if (zoomInButton) {
    zoomInButton.addEventListener('click', () => {
      gspx.trackEvent({
        name: GOOGLE_MAP_EVENT_NAMES.ZOOM_IN,
        type: GPX_EVENT_TYPES.INFO,
        feature: GPX_FEATURES.LEGACY,
        capability: GPX_CAPABILITIES.LEGACY,
        route: GPX_ROUTES.MAP,
        additionalKeys: {
          legacy_category: LEGACY_CATEGORY,
          legacy_name: 'Zoom in',
          Category: 'Google Map',
          'Launched date': new Date(),
        },
      });
    });
  }
};

export const addZoomOutButtonClickListener = () => {
  let zoomOutButton = document.querySelector('[aria-label="Zoom out"]');
  if (zoomOutButton) {
    zoomOutButton.addEventListener('click', () => {
      gspx.trackEvent({
        name: GOOGLE_MAP_EVENT_NAMES.ZOOM_OUT,
        type: GPX_EVENT_TYPES.INFO,
        feature: GPX_FEATURES.LEGACY,
        capability: GPX_CAPABILITIES.LEGACY,
        route: GPX_ROUTES.MAP,
        additionalKeys: {
          legacy_category: LEGACY_CATEGORY,
          legacy_name: 'Zoom out',
          Category: 'Google Map',
          'Launched date': new Date(),
        },
      });
    });
  }
};
